import { createSlice } from "@reduxjs/toolkit";
import { adminChangePassword, editAdminProfileImage, getUser, getUserEntity, signInSubmit, signOutSubmit, switchEntity } from "./authService";

const initialState = {
    entityVersion: 0,

    signInDetails: {
        isSignInLoading: null,
        isSignedIn: null,
        signInMessage: null,
    },

    userDetails: {
        isUserDetailsLoading: null,
        isUserDetails: null,
        userDetailsMessage: null,
        roleName: null,
        isLoggedIn: false,
        isLoading: false,
        hasCheckedAuth: false,
        details: {
            id: null,
            email: null,
            full_name: null,
            image_url: null,
            phone_number: null,
        },
    },

    adminImageUpdate: {
        imageUpdateStatus: null,
        message: null
    },

    adminChangePassword: {
        status: null,
        message: null
    },

     switchEntity: {
        status: null,
        message: null
    },

    userEntityDetails: {
        status: null,
        user_certificate_entity: null,
        userEntity_details: null,
    }
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
         incrementEntityVersion: (state) => {
        state.entityVersion += 1;
    }
    },
    extraReducers: (builder) => {
        builder.addCase(signInSubmit.pending, (state) => {
            state.signInDetails = {
                ...initialState.signInDetails,
                isSignInLoading: true,
                signInMessage: "Loading",
            };
        });

        builder.addCase(signInSubmit.rejected, (state, action) => {
            state.signInDetails = {
                ...initialState.signInDetails,
                isSignInLoading: false,
                isSignedIn: false,
                signInMessage: action.payload,
            };
        });

        builder.addCase(signInSubmit.fulfilled, (state, action) => {
            state.signInDetails = {
                ...initialState.signInDetails,
                isSignInLoading: false,
                isSignedIn: true,
                signInMessage: action.payload,
            };
        });
        builder.addCase(getUser.pending, (state, action) => {
            state.userDetails = {
                isUserDetailsLoading: true,
                isUserDetails: false,
                userDetailsMessage: "Loading",
                details: initialState.userDetails.details,
                isLoggedIn: false,
                roleName: null,
            };
        });

        builder.addCase(getUser.rejected, (state, action) => {
            state.userDetails = {
                isUserDetailsLoading: false,
                isUserDetails: false,
                userDetailsMessage: action.payload,
                details: initialState.userDetails.details,
                isLoggedIn: false,
                roleName: null,
                hasCheckedAuth: true,
            };
        });

        builder.addCase(getUser.fulfilled, (state, action) => {
            state.userDetails = {
                isUserDetailsLoading: false,
                isUserDetails: true,
                userDetailsMessage: "Successfully loaded user details",
                details: action.payload,
                isLoggedIn: true,
                roleName: action.payload?.role?.name,
                hasCheckedAuth: true,
            };
        });

        builder.addCase(signOutSubmit.pending, (state) => {
            state.userDetails.isLoading = true;
            state.userDetails.message = "Logging out...";
        });
        builder.addCase(signOutSubmit.fulfilled, (state) => {
            state.userDetails = {
                isLoggedIn: false,
                isLoading: false,
                message: "Logout successful.",
            };
        });
        builder.addCase(signOutSubmit.rejected, (state, action) => {
            state.userDetails.isLoading = false;
            state.userDetails.message = action.payload?.message || "Logout failed.";
        });
        builder.addCase(editAdminProfileImage.pending, (state) => {
            state.adminImageUpdate.imageUpdateStatus = 'loading';
            state.adminImageUpdate.message = null;
        });
        builder.addCase(editAdminProfileImage.fulfilled, (state, action) => {
            state.adminImageUpdate.imageUpdateStatus = 'success';
            state.adminImageUpdate.message = null;
        });
        builder.addCase(editAdminProfileImage.rejected, (state, action) => {
            state.adminImageUpdate.imageUpdateStatus = 'failed';
            state.adminImageUpdate.message = action.payload || 'Failed to update image';
        });
        builder.addCase(adminChangePassword.pending, (state) => {
            state.adminChangePassword.status = 'loading';
            state.adminChangePassword.message = null;
        });
        builder.addCase(adminChangePassword.fulfilled, (state, action) => {
            state.adminChangePassword.status = 'success';
            state.adminChangePassword.message = action.payload;
        });
        builder.addCase(adminChangePassword.rejected, (state, action) => {
            state.adminChangePassword.status = 'failed';
            state.adminChangePassword.message = action.payload || 'Failed to update image';
        });
         builder.addCase(switchEntity.pending, (state) => {
            state.switchEntity.status = 'loading';
            state.switchEntity.message = null;
        });
        builder.addCase(switchEntity.fulfilled, (state, action) => {
            state.switchEntity.status = 'success';
            state.switchEntity.message = action.payload;
        });
        builder.addCase(switchEntity.rejected, (state, action) => {
            state.switchEntity.status = 'failed';
            state.switchEntity.message = action.payload || 'Failed to switch the entity';
        });

          builder.addCase(getUserEntity.pending, (state) => {
            state.userEntityDetails.status = 'loading';
            state.userEntityDetails.user_certificate_entity = null;
            state.userEntityDetails.userEntity_details = null;
        });
        builder.addCase(getUserEntity.fulfilled, (state, action) => {
            state.userEntityDetails.status = 'success';
            state.userEntityDetails.user_certificate_entity = action.payload.code;
            state.userEntityDetails.userEntity_details = action.payload;
        });
        builder.addCase(getUserEntity.rejected, (state, action) => {
            state.userEntityDetails.status = 'failed';
            state.userEntityDetails.user_certificate_entity = null;
            state.userEntityDetails.userEntity_details = action.payload || 'Failed to get the entity';
        });
    }
});

// export const { login, logout } = authSlice.actions;
export const { incrementEntityVersion } = authSlice.actions;
export const selectUserDetails = (state) => state.auth.userDetails;
export const editAdminImage = (state) => state.auth.adminImageUpdate;
export const editAdminPassword = (state) => state.auth.adminChangePassword;
export const selectUserEntityDetails = (state) => state.auth.userEntityDetails;
export default authSlice.reducer;
